import React, { useEffect, useState } from 'react'
import * as AnalyticsService from '../../services/analytics'
import { useAnalyticsFilters } from '../../contexts/AnalyticsFilterContext'
import AnalyticsPageShell from './components/AnalyticsPageShell'
import MetricsSection from './components/MetricsSection'
import InsightsPanel from './components/InsightsPanel'
import SeriesChart from './components/SeriesChart'
import { getAnalyticsErrorMessage } from './utils'

const Campaigns = () => {
    const { rangeFilters } = useAnalyticsFilters()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [data, setData] = useState(null)

    useEffect(() => {
        let cancelled = false

        async function load() {
            setLoading(true)
            setError(null)
            try {
                const response = await AnalyticsService.getCampaigns(rangeFilters)
                if (!cancelled) setData(response)
            } catch (err) {
                if (!cancelled) setError(getAnalyticsErrorMessage(err))
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        load()
        return () => {
            cancelled = true
        }
    }, [rangeFilters])

    const series = {
        campanhas: data?.campaignsOverTime || [],
        'notificações push': data?.pushOverTime || []
    }

    return (
        <AnalyticsPageShell title='Análises de negócio — Campanhas' loading={loading} error={error} showWorkshopId>
            <MetricsSection title='Atividade no período (eventos)' metrics={data?.activity} />
            <SeriesChart title='Campanhas e notificações push ao longo do tempo' series={series} />
            <InsightsPanel insights={data?.insights} />
        </AnalyticsPageShell>
    )
}

export default Campaigns
